module.exports = __webpack_public_path__ + "assets/img/fb80c4889fbd7d016b1b93177074c9e7.png";